

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";
  import {BoListPanel, IOnOffHandlers} from "bonomo/dist";
  import {ILocker} from "@/model/Locker/lockerInterfaces";
  import {IScreensaver} from "@/model/Screensaver/screensaverInterfaces";
  import LinkChip from "@/components/shared/chips/LinkChip.vue";
  import {Prop} from "vue-property-decorator";
  import {UrlHelper} from "@/helpers/UrlHelper";
  import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
  import LockerSearch from "@/components/locker/widget/LockerSearch.vue";
  import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";
  import CreateButton from "@/components/shared/CreateButton.vue";
  import LockerNav from "@/components/locker/widget/LockerNav.vue";
  import ScreensaverLogs from "@/components/user/logs/ScreensaverLogs.vue";
  import BoListFilters from "@/components/shared/BoListFilters.vue";

  const lockerModule = namespace("lockerModule");
  const screensaverModule = namespace("screensaverModule");

  interface IScreensaverWithConnect extends IScreensaver {
    connectModel: boolean;
  }

  @Component({
    components: {
      BoListFilters,
      BoListPanel,
      CreateButton,
      LinkChip,
      LockerNav,
      LockerSearch,
      ScreensaverLogs,
      SimpleConfirmationDialog,
    }
  })
  export default class LockersScreensavers extends Vue {

    @lockerModule.Action('fetchLockers')
    private fetchLockers!: () => void;
    @lockerModule.Getter('lockers')
    private lockers!: ILocker[];

    @screensaverModule.Action('connectLockerScreensaver')
    private connectLockerScreensaver!: ({lockerId, screensaverId, connected}: {lockerId: number, screensaverId: number, connected: boolean}) => void;
    @screensaverModule.Action('fetchScreensavers')
    private fetchScreensavers!: () => void;
    @screensaverModule.Action('fetchLockersScreensaverIds')
    private fetchLockersScreensaverIds!: (params: {lockerId: number}) => void;
    @screensaverModule.Action('setScreensaverActive')
    protected setScreensaverActive!: (params: {screensaverId: number, active: boolean}) => any;
    @screensaverModule.Getter('screensavers')
    private screensavers!: IScreensaver[];
    @screensaverModule.Getter('lockersScreensaverIds')
    private connectedIds!: number[];

    @Prop()
    protected lockerId!: number;

    // private locker?: ILocker;
    private search: string = '';
    private onlyActive: boolean = false;
    private onlyAssigned: boolean = true;
    private connectionsLoading: boolean = true;
    private subscribes: IOnOffHandlers = {};
    private currentScreensaver: IScreensaver|null = null
    private showConfirmationDialog: boolean = false;

    protected get extraFilters(): any {
      return {
        lockerId: this.lockerId,
      };
    }

    protected get headers(): BetterDataTableHeader[] {
      return  [
        { text: this.$t('common.id'), align: 'start', sortable: true, value: 'id' },
        { text: this.$t('common.order'), align: 'start', value: 'order' },
        { text: this.$t('common.name'), align: 'start', value: 'name' },
        { text: this.$t('common.active'), align: 'center', value: 'active' },
        { text: this.$t('common.edit'), align: 'center', value: 'editCta', sortable: false },
        { text: this.$t('common.where'), align: 'center', value: 'shareCta', sortable: false },
        { text: this.$t('common.assigned'), align: 'center', value: 'connectModel' },
      ];
    }

    protected get screensaverItems(): IScreensaverWithConnect[] {
      return this.screensavers.map(
          each => Object.assign({}, each, {connectModel: this.hasScreensaver(each.id)})
      )
          .filter(each => {
            if (this.onlyActive && !each.active) {
              return false;
            }
            if (this.onlyAssigned && !each.connectModel) {
              return false;
            }
            if (this.search && this.search.length) {
              const searchString = (each.id + ' ' + each.name).toLowerCase();
              if (!searchString.includes(this.search.toLowerCase())) {
                return false;
              }
            }
            return true;
          })
          ;
    }

    protected get lockerItems() {
      const lockers = this.lockers;
      const ret = (lockers || [])
        .map((locker: ILocker) => ({
          text: locker.name + ' (#' + locker.id + ')',
          value: locker.id,
        }));
      ret.unshift({
        text: '',
        value: 0,
      });
      return ret;
    }

    protected get combinedSearch() {
      // we make sure search is triggered even when search input is empty. otherwise our custom filter is not applied
      //  also A : B ensures that seach changes when the active/assigned switch changes
      return (this.search||'').toString() +
        (this.onlyAssigned ? 'A' : 'B') +
        (this.onlyActive ? 'A' : 'B');
    }

    created() {
      // this.loadData(true);
      this.subscribes = this.$ons({
        'login.OK': this.loadData,
        'backend.call.OK.screensaversLoaded': this.makeScreensaverItems,
        'backend.call.OK.connectionIdsLoaded': this.makeScreensaverItems,
      });
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    private loadData(initial: boolean = false) {
      this.fetchScreensavers();
      // lockers are loaded by locker selector, we don't have to load here too
    }

    private editUrl(screensaverId: number) {
      return UrlHelper.mayorScreensaverEdit(screensaverId);
    }

    private hasScreensaver(screensaverId: number) {
      return this.connectedIds.indexOf(screensaverId) !== -1;
    }

    private makeScreensaverItems() {
      this.connectionsLoading = false;
    }

    private onCreateButton() {
      this.$router.push({name: 'screensaverCreate', params: {type: 'service_provider_hero'}});
    }

    private onLockerSelected(lockerId: number) {
      if (lockerId != this.lockerId) {
        this.$router.push({name: 'lockersScreensavers', params: {lockerId: '' + lockerId}});
      }
      return;
    }

    private onSwitch(screensaverId: number, connected: boolean) {
      this.connectionsLoading = true;
      this.connectLockerScreensaver(
          {
            lockerId: this.lockerId,
            screensaverId,
            connected
          }
      );
    }

    private onToggleConfirmed(item: IScreensaver) {
      this.setScreensaverActive({screensaverId: item.id, active: !item.active});
      this.showConfirmationDialog = false;
    }

    private onToggleScreensaverClicked(item: IScreensaver){
      this.showConfirmationDialog = true;
      this.currentScreensaver = item;
    }

  }
